<nz-modal [(nzVisible)]="isVisible" nzTitle="Password Change Required" [nzClosable]="false" [nzMaskClosable]="false"
    [nzKeyboard]="false" nzCentered [nzFooter]="modalFooter">

    <ng-container *nzModalContent>
        <nz-alert nzType="warning" nzMessage="Action Required"
            nzDescription="Your password has expired or does not meet our security policies. You must update it to continue."
            nzShowIcon style="margin-bottom: 16px;">
        </nz-alert>

        <div *ngIf="policyErrors.length > 0" class="policy-errors">
            <p><strong>Password Requirements:</strong></p>
            <ul>
                <li *ngFor="let err of policyErrors" class="text-danger">{{ err }}</li>
            </ul>
        </div>

        <form nz-form [formGroup]="passwordForm" nzLayout="vertical">
            <nz-form-item>
                <nz-form-label nzRequired nzFor="newPassword">New Password</nz-form-label>
                <nz-form-control nzErrorTip="Please input your new password!">
                    <nz-input-group nzPrefixIcon="lock" [nzSuffix]="suffixTemplateNew">
                        <input [type]="passwordVisible ? 'text' : 'password'" nz-input formControlName="newPassword" id="newPassword"
                            placeholder="Enter new password" />
                    </nz-input-group>
                    <ng-template #suffixTemplateNew>
                        <span nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
                            (click)="passwordVisible = !passwordVisible" style="cursor: pointer;">
                        </span>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label nzRequired nzFor="confirmPassword">Confirm Password</nz-form-label>
                <nz-form-control [nzErrorTip]="confirmErrorTpl">
                    <nz-input-group nzPrefixIcon="lock" [nzSuffix]="suffixTemplateConfirm">
                        <input [type]="confirmPasswordVisible ? 'text' : 'password'" nz-input formControlName="confirmPassword" id="confirmPassword"
                            placeholder="Confirm new password" />
                    </nz-input-group>
                    <ng-template #suffixTemplateConfirm>
                        <span nz-icon [nzType]="confirmPasswordVisible ? 'eye-invisible' : 'eye'"
                            (click)="confirmPasswordVisible = !confirmPasswordVisible" style="cursor: pointer;">
                        </span>
                    </ng-template>
                    <ng-template #confirmErrorTpl let-control>
                        <ng-container *ngIf="control.hasError('required')">Please confirm your password</ng-container>
                        <ng-container *ngIf="control.hasError('mismatch')">Passwords do not match</ng-container>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>
        </form>
    </ng-container>

    <ng-template #modalFooter>
        <button nz-button nzType="primary" [nzLoading]="isSubmitting" (click)="submitForm()">
            Update Password
        </button>
    </ng-template>
</nz-modal>
